"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useContentLock;

var _react = require("react");

var _contexts = require("../contexts");

var _boxPositioner = require("./box-positioner");

require("./content-lock.scss");

const BLUR_CLASS = "donation-encourager__lock-content";
const BLUR_CLASS_ACTIVE = "content-lock-active"; // gives gradient to last content block before 1st donation encourager box
// + blur for all following content blocks

function useContentLock(_ref, targets, boxes) {
  let {
    contentLockEnabled
  } = _ref;
  const {
    boxesEnabled,
    wrapperClass
  } = (0, _react.useContext)(_contexts.Settings);
  const isInitiallyActive = contentLockEnabled && boxesEnabled;
  const [contentLockActive, setContentLockActive] = (0, _react.useState)(isInitiallyActive);
  (0, _react.useEffect)(() => setContentLockActive(isInitiallyActive), [isInitiallyActive]);

  const unlockContent = () => setContentLockActive(false);

  const blurEls = useChildReducer(targets, wrapperClass, blurElGetter, boxes);
  useClass(blurEls, true, BLUR_CLASS);
  useClass(blurEls, contentLockActive, BLUR_CLASS_ACTIVE);
  return [contentLockActive, unlockContent];
}

function useClass(elements, active, className) {
  (0, _react.useEffect)(() => {
    elements.forEach(el => active ? el.classList.add(className) : "");
    return () => {
      elements.forEach(el => el.classList.remove(className));
    };
  }, [elements, active, className]);
}

function blurElGetter(acc, allChildren, firstBoxIndex, wrapperClass) {
  const childrenAfterFirstBox = allChildren.slice(firstBoxIndex).filter(el => !el.classList.contains(wrapperClass));
  return [...acc, ...childrenAfterFirstBox];
}

function useChildReducer(targetElements, wrapperClass, reducer, trigger) {
  return (0, _react.useMemo)(() => {
    ;
    [].push(trigger);
    return targetElements.reduce((acc, targetElement) => {
      const allChildren = (0, _boxPositioner.getChildArray)(targetElement);
      const firstBox = allChildren.find(c => c.classList.contains(wrapperClass));
      const firstBoxIndex = allChildren.indexOf(firstBox);
      return reducer(acc, allChildren, firstBoxIndex, wrapperClass);
    }, []);
  }, [targetElements, wrapperClass, reducer, trigger]);
}